// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"265":"f6588aa8","559":"11adee71","953":"878f91a3","974":"37d4a4e2"}[chunkId] + ".css";
};